import request from '@/utils/request.js'
import axios from 'axios'
import Cookies from 'js-cookie'
const hostUrl = process.env.VUE_APP_FILE_API
const BID_FILE_API = process.env.VUE_APP_BID_FILE_API

// 获取服务器ali-oss的签名
export function signatureApi(platform, data) {
  return request(
    {
      url: hostUrl + `/attachments/upload-policy`,
      method: 'post',
      data: { platform, ...data }
    },
    false
  )
}

// 获取资源上传凭证 （资源上传使用 -- 目前企业门户使用）
export function getUploadPolicy() {
  return request(
    {
      url: hostUrl + '/resources/upload-policy',
      method: 'post'
    },
    false
  )
}

// 上传文件到ali-oss
export function uploadFileApi(url, data, progressEvent) {
  return request(
    {
      url: url,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      withCredentials: false,
      onUploadProgress: progressEvent,
      data
    },
    false,
    true
  )
}

// 上传文件前，获取groupId
export function getGroupApi(data) {
  return request(
    {
      url: hostUrl + `/attachment-groups`,
      method: 'post',
      data
    },
    false
  )
}

// 通过groupId获取到文件列表
export function getFileListByGroupIdApi(params) {
  return request(
    {
      url: hostUrl + `/attachment-groups/${params.groupId}/attachments`,
      method: 'get'
    },
    false
  )
}

// 查询附件信息列表
export function getFileListByFileIdsApi(params) {
  return request(
    {
      url: `${hostUrl}/attachments`,
      method: 'get',
      params: { attachmentIds: params.attachmentId }
    },
    false
  )
}

// 根据业务fileId获取文件地址，下载和预览场景使用：目前图片上传也使用该接口
export function getFileUrlByFileIdApi(params) {
  return request(
    {
      url: hostUrl + `/attachments/${params.attachmentId}/access-url`,
      method: 'get'
    },
    false
  )
}

// 获取文件的预览地址
export function getFilePreviewUrlApi(attachmentId, pattern) {
  return request(
    {
      url: `${hostUrl}/attachments/${attachmentId}/patterns/${pattern}/preview-url`,
      method: 'get'
    },
    false
  )
}

// 删除文件
export function deleteFileApi(data) {
  return request({
    url: hostUrl + `/attachments/${data.attachmentId}`,
    method: 'delete'
  })
}

// 将附件转换为pdf
export function attachmentToPdfApi(attachmentId) {
  return request({
    url: `${hostUrl}/attachments/${attachmentId}/convert/pdf`,
    method: 'post'
  })
}

// 查询附件转换为pdf的结果
export function getAttachmentToPdfStatusApi(attachmentId) {
  return request({
    url: `${hostUrl}/attachments/${attachmentId}/convert/pdf/result`,
    method: 'get'
  })
}

// 根据 groupIds 获取所有附件信息
export function getAllFilesByGroupIdApi(groupIds) {
  return request({
    url: `${hostUrl}/attachment-groups/attachments`,
    method: 'get',
    params: { groupIds }
  })
}

// html 转 pdf
export function htmlToPdfApi(data, isNeedLoading = true) {
  return request(
    {
      url: hostUrl + `/attachment-tools/html-to-pdf`,
      method: 'post',
      data: { ...data, platform: process.env.VUE_APP_PLATFORM_CONSTANT }
    },
    isNeedLoading
  )
}

// pdf 合并
export function pdfMergeApi(params) {
  return request({
    url: hostUrl + '/attachment-tools/marge',
    method: 'get',
    params
  })
}

// pdf 添加水印
export function setWatermarkApi(watermarkType, watermarkWord, data) {
  // 如果在cookie中获得XSRF-TOKEN，则写入到header中给后台校验
  const xsrf = Cookies.get('XSRF-TOKEN') || ''
  const ac = Cookies.get('X-JCZH-AC') || ''

  return axios
    .post(
      `${hostUrl}/attachment-tools/watermark?watermarkType=${watermarkType}&watermarkWord=${watermarkWord}`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-XSRF-TOKEN': xsrf,
          'X-JCZH-AC': ac
        },
        responseType: 'arraybuffer'
      }
    )
    .then(response => Promise.resolve(response.data))
}

/**
 * 上传加密后的投标文件
 */
export function uploadDecryptBidFileApi(url, data, progressEvent) {
  return request(
    {
      url: BID_FILE_API + '/bid-file/upload',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data,
      onUploadProgress: progressEvent
    },
    false,
    true
  )
}

// 分页查询下载列表
export function getDownloadListApi(platform, params) {
  return request({
    url: hostUrl + `/attachment-downloads/platforms/${platform}/page`,
    method: 'get',
    params
  })
}

// 删除下载
export function deleteDownloadFileApi(downloadId) {
  return request({
    url: hostUrl + `/attachment-downloads/${downloadId}`,
    method: 'delete'
  })
}

// 重新下载
export function reDownloadFileApi(downloadId) {
  return request({
    url: hostUrl + `/attachment-downloads/${downloadId}/retry`,
    method: 'post'
  })
}

// 获取结果文件访问地址
export function getAccessFileApi(downloadId) {
  return request({
    url: hostUrl + `/attachment-downloads/${downloadId}/result-file/access-url`,
    method: 'get'
  })
}

// 下载记录
export function downloadsHistoryApi(data) {
  return request({
    url: hostUrl + `/attachments/downloads/history`,
    method: 'post',
    data: data
  })
}

/**
 * @typedef HtmlToPdfPostData
 * @property {string} name 文件名
 * @property {string} content html内容
 * @property {Object} watermark 水印信息
 * @property {number} watermark.watermarkType 水印类型（1：普通文字）
 * @property {string} watermark.wtaermarkWord 水印文字
 */

/**
 * html 转 pdf (返回二进制文件流，直接下载)
 * @param {HtmlToPdfPostData} data
 * @returns {Promise<void>|*}
 */
export function downloadHtmlToPdfApi(data) {
  return request(
    {
      url: hostUrl + '/resource-tools/html-to-pdf',
      method: 'post',
      data,
      responseType: 'blob'
    },
    false
  )
}
